module.exports = "../images/northern-pike-fishing-ontario-2@2x.jpg?v=7da213e";